window.ArtShiney= window.ArtShiney || {};
window.ArtShiney.CustomizeProduct = (function () {

    var URL = "https://smoddo.myshopify.com/pages/you-can-design-this-jewelry";
    var BUTTON_ID = "ArtShiney-customizable-button";
    var BUTTON_TEXT = "Customize";
    var IS_CUSTOMIZE_ABLE = "true"
    var HANDLES = [{"customizable":true,"fontTextCustomizeInfo":{"fontInfos":[{"fontName":"Arial","uid":"cofont1"},{"fontName":"lucida handwriting","uid":"cofont2"},{"fontName":"Italianno-Regular","uid":"cofont4"},{"fontName":"Georgia","uid":"cofont5"},{"fontName":"VNI-Brush","uid":"cofont6"},{"fontName":"CommercialScript BT","uid":"cofont7"},{"fontName":"AlexBrush","uid":"cofont8"},{"fontName":"CAI978","uid":"cofont9"},{"fontName":"DisneyPark","uid":"cofont10"},{"fontName":"Doctor Soos Bold","uid":"cofont11"},{"fontName":"Script MT Bold","uid":"cofont12"},{"fontName":"Scriptina","uid":"cofont14"}],"handle":"s925-personalized-necklace","printAreas":[{"attributeName":"Name engraving","maxTextNum":20,"name":"Name engraving"}]},"handler":"s925-personalized-necklace"},{"customizable":false,"handler":"whispering-lips"},{"customizable":false,"handler":"beaded-evil-eye-bracelet"},{"customizable":false,"handler":"pearl-and-lapis-lazuli-bracelet"},{"customizable":false,"handler":"golden-chime-anklet"},{"customizable":false,"handler":"retro-triangle-earrings"},{"customizable":false,"handler":"serpentine-evil-eye"},{"customizable":false,"handler":"18k-gold-one-size-devils-ring"},{"customizable":false,"handler":"18k-shell-texture-open-ring"},{"customizable":false,"handler":"gilded-orb-anklet"},{"customizable":false,"handler":"pure-strand-anklet"},{"customizable":false,"handler":"18k-gold-vintage-evils-eye"},{"customizable":false,"handler":"wave-bangle-thin"},{"customizable":false,"handler":"light-beaded-necklace"},{"customizable":true,"fontTextCustomizeInfo":{"fontInfos":[{"fontName":"Arial","uid":"cofont1"},{"fontName":"lucida handwriting","uid":"cofont2"},{"fontName":"Italianno-Regular","uid":"cofont4"},{"fontName":"Georgia","uid":"cofont5"},{"fontName":"VNI-Brush","uid":"cofont6"},{"fontName":"CommercialScript BT","uid":"cofont7"},{"fontName":"AlexBrush","uid":"cofont8"},{"fontName":"CAI978","uid":"cofont9"},{"fontName":"DisneyPark","uid":"cofont10"},{"fontName":"Doctor Soos Bold","uid":"cofont11"},{"fontName":"Script MT Bold","uid":"cofont12"},{"fontName":"Scriptina","uid":"cofont14"},{"fontName":"Autumn Chant","uid":"cofont15"}],"handle":"personalized-necklace-1","printAreas":[{"attributeName":"Name engraving ","maxTextNum":18,"name":"Name engraving "}]},"handler":"personalized-necklace-1"},{"customizable":false,"handler":"radiant-zirconia-anklet"},{"customizable":false,"handler":"butterfly-anklet"},{"customizable":false,"handler":"heartfelt-duo-layer-anklet"},{"customizable":false,"handler":"duo-square-strand-anklet"},{"customizable":false,"handler":"sunlit-seashell-bracelet"},{"customizable":false,"handler":"square-beads-necklace"},{"customizable":false,"handler":"18k-gold-drop-charm-necklace"},{"customizable":false,"handler":"golden-pearl-cascade-bracelet"},{"customizable":false,"handler":"andalusia-set-in-18k-gold"},{"customizable":false,"handler":"drama-pendant-in-18k-gold"},{"customizable":false,"handler":"fun-huggie-earrings"},{"customizable":false,"handler":"asymmetric-earrings-18k-gold"},{"customizable":false,"handler":"seashell-elegance-earrings"},{"customizable":false,"handler":"luxe-textured-earrings"},{"customizable":false,"handler":"round-ring"},{"customizable":false,"handler":"butterfly-gem-ring"},{"customizable":false,"handler":"hammered-ring"},{"customizable":false,"handler":"petite-baguette-ring-1"},{"customizable":false,"handler":"duo-hearts"},{"customizable":false,"handler":"royal-charm-ring-1"},{"customizable":false,"handler":"retro-silver-earrings"},{"customizable":false,"handler":"coco-earrings-in-18k-gold"},{"customizable":false,"handler":"star-choker"},{"customizable":false,"handler":"aurora-layered-gold-necklace"},{"customizable":false,"handler":"snowflake-necklace"},{"customizable":false,"handler":"bubbly-heart-pendant-necklace"},{"customizable":false,"handler":"oval-pearl-clip-on-earrings"},{"customizable":false,"handler":"gold-plated-link-jewelry-set"},{"customizable":false,"handler":"honey-set-1"},{"customizable":false,"handler":"gold-and-crystal-link-necklace"},{"customizable":false,"handler":"edge-cuff"},{"customizable":false,"handler":"north-star-pendant-necklace"},{"customizable":false,"handler":"textured-heart-set"},{"customizable":false,"handler":"retro-choker"},{"customizable":false,"handler":"the-baguette"},{"customizable":false,"handler":"heart-charm-hoop-earrings"},{"customizable":false,"handler":"glam-tassel-statement-earrings"},{"customizable":false,"handler":"serpent-drop-earrings"},{"customizable":false,"handler":"heartbeat-hoops-1"},{"customizable":false,"handler":"pearl-love-earrings"},{"customizable":false,"handler":"crystal-retro-earrings-1"},{"customizable":false,"handler":"luxe-link-cuff-bracelet"},{"customizable":false,"handler":"pure-s925-silver-tennis-bracelet"},{"customizable":false,"handler":"bambou-or-1"},{"customizable":false,"handler":"selina-retro-hoops"},{"customizable":false,"handler":"retro-lux"},{"customizable":false,"handler":"sun-shaped-diamond-encrusted-earrings"},{"customizable":false,"handler":"studded-cross"},{"customizable":false,"handler":"eterna-wave-hoops"},{"customizable":false,"handler":"luxe-curve-cuff"},{"customizable":false,"handler":"charme-necklace"},{"customizable":false,"handler":"pearl-cascade-earrings"},{"customizable":false,"handler":"oblate-necklace"},{"customizable":false,"handler":"harmony-necklace"},{"customizable":false,"handler":"porcelain-necklace"},{"customizable":false,"handler":"minimalist-pearl-chain-necklace"},{"customizable":false,"handler":"sun-and-pearl-necklace"},{"customizable":false,"handler":"pearl-drop-earrings"},{"customizable":false,"handler":"starfish-drop-earrings"},{"customizable":false,"handler":"ocean-inspired-earring-set"},{"customizable":false,"handler":"modern-u-shaped-spiral-earrings"},{"customizable":false,"handler":"bold-red-earrings"},{"customizable":false,"handler":"pearl-chain-bracelet-and-necklace-set"},{"customizable":false,"handler":"chain-and-twist-bracelet-and-necklace-set"},{"customizable":false,"handler":"bold-link-bracelet-and-necklace-set"},{"customizable":false,"handler":"pearl-and-emerald-set"},{"customizable":false,"handler":"irregular-ring"},{"customizable":false,"handler":"wave-pattern-ring"},{"customizable":false,"handler":"t-bar-ring-adjustable"},{"customizable":false,"handler":"rainbow-baguette-rings"},{"customizable":false,"handler":"crystal-heart-earrings"},{"customizable":false,"handler":"guardian-layered-necklace"},{"customizable":false,"handler":"aurora-ring"},{"customizable":false,"handler":"gold-silver-harmony-bracelet"},{"customizable":false,"handler":"golden-pearl-link-necklace"},{"customizable":false,"handler":"love-ring"},{"customizable":false,"handler":"lucky-elephant-necklace"},{"customizable":false,"handler":"heart-drop-earrings"},{"customizable":false,"handler":"ethereal-butterfly-pendant-necklace"},{"customizable":false,"handler":"pearl-heart-ring"},{"customizable":false,"handler":"textured-heart-stud-earrings"},{"customizable":false,"handler":"emerald-heart-charm-necklace"},{"customizable":false,"handler":"turquoise-feather-pendant-necklace"},{"customizable":false,"handler":"raw-heart-cord-necklace"},{"customizable":false,"handler":"classic-rope-chain-necklace"},{"customizable":false,"handler":"sleek-herringbone-chain-necklace"},{"customizable":true,"fontTextCustomizeInfo":{"fontInfos":[{"fontName":"Arial","uid":"cofont1"},{"fontName":"lucida handwriting","uid":"cofont2"},{"fontName":"Italianno-Regular","uid":"cofont4"},{"fontName":"Georgia","uid":"cofont5"},{"fontName":"VNI-Brush","uid":"cofont6"},{"fontName":"CommercialScript BT","uid":"cofont7"},{"fontName":"AlexBrush","uid":"cofont8"},{"fontName":"CAI978","uid":"cofont9"},{"fontName":"DisneyPark","uid":"cofont10"},{"fontName":"Doctor Soos Bold","uid":"cofont11"},{"fontName":"Script MT Bold","uid":"cofont12"},{"fontName":"Scriptina","uid":"cofont14"},{"fontName":"Autumn Chant","uid":"cofont15"},{"fontName":"BarbieFont","uid":"cofont16"}],"handle":"xo-handmade-necklace","printAreas":[{"attributeName":"Name engraving","maxTextNum":10,"name":"Name engraving"}]},"handler":"xo-handmade-necklace"},{"customizable":true,"fontTextCustomizeInfo":{"fontInfos":[{"fontName":"Arial","uid":"cofont1"},{"fontName":"lucida handwriting","uid":"cofont2"},{"fontName":"Italianno-Regular","uid":"cofont4"},{"fontName":"Georgia","uid":"cofont5"},{"fontName":"VNI-Brush","uid":"cofont6"},{"fontName":"CommercialScript BT","uid":"cofont7"},{"fontName":"AlexBrush","uid":"cofont8"},{"fontName":"CAI978","uid":"cofont9"},{"fontName":"DisneyPark","uid":"cofont10"},{"fontName":"Doctor Soos Bold","uid":"cofont11"},{"fontName":"Script MT Bold","uid":"cofont12"},{"fontName":"Scriptina","uid":"cofont14"},{"fontName":"Autumn Chant","uid":"cofont15"}],"handle":"duo-necklace","printAreas":[{"attributeName":"Name engraving - Left  ","maxTextNum":18,"name":"Name engraving - Left  "},{"attributeName":"Name engraving - Right      ","maxTextNum":18,"name":"Name engraving - Right      "}]},"handler":"duo-necklace"},{"customizable":false,"handler":"baguette-stone-ring"},{"customizable":false,"handler":"baguette-cut-band"},{"customizable":false,"handler":"pearl-line-ring"}]
    var GREETING_CARD_INFOS = [{"id":1,"knifeImageUrl":"https:\/\/shineoss.oss-accelerate.aliyuncs.com\/normal\/734f4b5f-6139-4622-95d2-dd7c658b5925.png","name":"FYL_ Greeting card","printAreas":[{"inputType":2,"name":"Greeting card content","textNum":500}]}]
    var UploadFileApiUrl = "https://f.artshiney.com/file/upload"
    var ShopId = "4136"

    // 输入框类型
    var INPUT_TYPE_INPUT = 1
    var INPUT_TYPE_TEXTAREA = 2

    var CustomizeProduct = {};

    CustomizeProduct.init = function () {
        var productHandle = CustomizeProduct.ProductUtil.findHandle();
        if (!productHandle) {
            warn("Could not find handle");
            return;
        }
        productHandle = decodeURI(productHandle)
        warn("handle:" + productHandle)
        // is product customizable
        var currentHandlerInfo = null
        for (const handle of HANDLES) {
            if(handle.handler === productHandle){
                currentHandlerInfo = handle
            }
        }
        if(!currentHandlerInfo){
            warn("Could not find handle");
            return
        }
        if(window.ArtShineyCustomizeProductDone){
            return
        }
        window.ArtShineyCustomizeProductDone = true
        // is customizable
        var isCustomizableHandler = currentHandlerInfo.customizable
        // is product have printareas
        var isCustomizeRun = false
        if(currentHandlerInfo.fontTextCustomizeInfo){
            // init text customize
            CustomizeProduct.Run.fontTextCustomizeRun(currentHandlerInfo.fontTextCustomizeInfo.printAreas, currentHandlerInfo.fontTextCustomizeInfo.fontInfos)
            isCustomizeRun = true
        }
        if(currentHandlerInfo.projectModeCustomizeInfo){
            CustomizeProduct.Run.projectModeCustomizeRun(currentHandlerInfo.projectModeCustomizeInfo.imageAreaInfo)
            isCustomizeRun = true
        }



        if(isCustomizableHandler && !isCustomizeRun){
            CustomizeProduct.ProductUtil.getProduct(productHandle, function (err, product) {
                if (err || !product) {
                    warn("Error while getting product");
                    return;
                }
                // init other customize
                CustomizeProduct.Run.customizeRun(product);
            })
        }

        // greeting Card
        // if(currentHandlerInfo.greetingId){
        //     for (const greetingcardinfo of GREETING_CARD_INFOS) {
        //         if(greetingcardinfo.id === currentHandlerInfo.greetingId){
        //             CustomizeProduct.Run.greetingCardRun(greetingcardinfo)
        //         }
        //     }
        // }

    };

    CustomizeProduct.FetchUtil = {
        uploadFile: function(fileEle,  imageEle, hiddenEle){
            return function (){
                if (!fileEle.files.length){
                    imageEle.removeAttribute("src")
                    hiddenEle.removeAttribute("value")
                    imageEle.style.display = "none"
                    return
                }
                var fileObj = fileEle.files[0];
                if (fileObj.size > 10 * 1024 * 1024) {
                    alert('Maximum file size 10 MB')
                    return
                }
                var form = new FormData();
                form.append("file", fileObj);
                form.append("shopId", ShopId);
                xhr = new XMLHttpRequest();
                xhr.open("post", UploadFileApiUrl, true);
                // request success
                xhr.onload = function(evt){
                    var data = JSON.parse(evt.target.responseText);
                    console.log(data)
                    if(data.code === '00200') {
                        warn("Upload File success");
                        imageEle.setAttribute("src", data.data)
                        hiddenEle.setAttribute("value", data.data)
                        imageEle.style.display = "block"
                    }else{
                        warn("Upload File fail, msg:" + data.msg);
                    }
                };
                // request error
                xhr.onerror =  function(evt){
                    warn("Upload File fail, err:" + evt)
                };



                xhr.send(form);
            }
        }
    }

    CustomizeProduct.ProductUtil = {
        findHandle: function () {
            var nodeList = document.querySelectorAll("link[type='application/json+oembed']");
            var linkElements = Array.prototype.slice.call(nodeList);

            var srcAttributes = linkElements.map(function (link) {
                return link.getAttribute("src");
            });

            srcAttributes = srcAttributes.filter(function (attribute) {
                return !!attribute;
            });

            var links = srcAttributes.concat([location.pathname]);

            for (var i = 0; i < links.length; i++) {
                var match = CustomizeProduct.Regex.productHandleRegex.exec(links[i]);
                if (match) {
                    return match[1];
                }
            }
        },
        getProduct: function (handle, callback) {
            var jsonProduct;
            if (window.json_product) {
                jsonProduct = window.json_product;
                if (jsonProduct && jsonProduct.tags && jsonProduct.variants) {
                    return callback && callback(null, jsonProduct);
                }
            }

            var script = document.getElementById("ProductJson-product-template");
            if (script) {
                try {
                    jsonProduct = JSON.parse(script.innerText);
                    if (jsonProduct && jsonProduct.tags && jsonProduct.variants) {
                        return callback && callback(null, jsonProduct);
                    }
                } catch (e) {
                    console.log(e);
                }
            }

            fetch("/products/" + handle + ".json")
                .then(function (response) {
                    return response.json();
                })
                .then(function (value) {
                    var product = value.product;
                    if (product && product.tags && product.variants) {
                        callback && callback(null, product);
                    } else {
                        callback && callback(true);
                    }
                }, callback)
        },
    };

    CustomizeProduct.Run = {
        fontTextCustomizeRun: function(printAreaInfos, fontInfos){
            // add font style
            const head = document.getElementsByTagName('head')[0];
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = 'https://www.artshiney.com/papi/shopify/css/fonts.css';
            link.media = 'all';
            head.appendChild(link);

            // get add to cart button
            var addToCartButton = CustomizeProduct.ButtonUtil.getAddToCarTButton();
            if (!addToCartButton) {
                warn("Could not find cart button");
                return null;
            }
            // new container div
            var containerEle = document.createElement("div")
            if(addToCartButton.closest("form")){
                addToCartButton.closest("form").prepend(containerEle)
            }else{
                addToCartButton.parentElement.prepend(containerEle)
            }

            for (let printAreaInfo of printAreaInfos) {
                let ele = CustomizeProduct.EleUtil.newPrintAreaEle(printAreaInfo, fontInfos);
                containerEle.append(ele)
            }


            // hide buy and pay button
            var buyButton = CustomizeProduct.ButtonUtil.getBuyButton();
            var payButton = CustomizeProduct.ButtonUtil.getPayButton();
            if(buyButton){
                warn("hidden buy button")
                buyButton.style.display = "none";
            }
            if(payButton){
                warn("hidden pay button")
                payButton.style.display = "none";
            }
        },
        projectModeCustomizeRun: function(imageAreaInfo){


            // get add to cart button
            var addToCartButton = CustomizeProduct.ButtonUtil.getAddToCarTButton();
            if (!addToCartButton) {
                warn("Could not find cart button");
                return null;
            }
            // new container div
            var containerEle = document.createElement("div")
            if(addToCartButton.closest("form")){
                addToCartButton.closest("form").prepend(containerEle)
            }else{
                addToCartButton.parentElement.prepend(containerEle)
            }

            let ele = CustomizeProduct.EleUtil.newImageEle(imageAreaInfo);
            containerEle.append(ele)


            // hide buy and pay button
            var buyButton = CustomizeProduct.ButtonUtil.getBuyButton();
            var payButton = CustomizeProduct.ButtonUtil.getPayButton();
            if(buyButton){
                warn("hidden buy button")
                buyButton.style.display = "none";
            }
            if(payButton){
                warn("hidden pay button")
                payButton.style.display = "none";
            }
        },
        customizeRun: function(product){


            var addToCartButton = CustomizeProduct.ButtonUtil.getAddToCarTButton();
            if (!addToCartButton) {
                warn("Could not find cart button");
                return null;
            }
            var buyButton = CustomizeProduct.ButtonUtil.getBuyButton();
            var payButton = CustomizeProduct.ButtonUtil.getPayButton();

            var customizeBtn = addToCartButton.cloneNode(false);
            customizeBtn.innerText = BUTTON_TEXT;
            if (customizeBtn.tagName.toLowerCase() === "input") {
                customizeBtn.setAttribute("value", BUTTON_TEXT);
            }
            customizeBtn.setAttribute("id", BUTTON_ID);
            customizeBtn.setAttribute("name", BUTTON_ID);
            customizeBtn.setAttribute("type", "button");
            customizeBtn.removeAttribute("data-action");
            customizeBtn.removeAttribute("data-add-to-cart");
            customizeBtn.style.marginTop = "10px";
            addToCartButton.parentNode.appendChild(customizeBtn);
            if(addToCartButton){
                warn("hidden add to cart button")
                addToCartButton.style.display = "none";
            }
            if(buyButton){
                warn("hidden buy button")
                buyButton.style.display = "none";
            }
            if(payButton){
                warn("hidden pay button")
                payButton.style.display = "none";
            }

            customizeBtn.setAttribute("visible", "");
            CustomizeProduct.ButtonUtil.applyEventListener(customizeBtn, product);
        },
        greetingCardRun: function(greetingCard){
            // get add to cart button
            var addToCartButton = CustomizeProduct.ButtonUtil.getAddToCarTButton();
            if (!addToCartButton) {
                warn("Could not find cart button");
                return null;
            }
            var eleHeight = "40px"



            // new container div
            var containerEle = document.createElement("div")
            containerEle.style.display = "flex"
            containerEle.style.marginBottom = "20px"
            addToCartButton.parentElement.prepend(containerEle)

            // title
            var titleEle = document.createElement("h2")
            titleEle.innerHTML = "Greeting Card"
            addToCartButton.parentElement.prepend(titleEle)

            // knife Image
            var knifeImageEle = document.createElement("img");
            knifeImageEle.src = greetingCard.knifeImageUrl
            knifeImageEle.style.width = "40%"
            knifeImageEle.addEventListener("click", ()=>{
                CustomizeProduct.EleUtil.showBigImage(greetingCard.knifeImageUrl)
            })
            containerEle.append(knifeImageEle)

            // printArea container
            var printAreaContainerEle = document.createElement("div")
            printAreaContainerEle.style.width = "60%"
            printAreaContainerEle.style.marginLeft = "5px"

            containerEle.append(printAreaContainerEle)

            // printArea ele
            for (const printArea of greetingCard.printAreas) {
                var inputEle = null;
                if(printArea.inputType === INPUT_TYPE_INPUT){
                    inputEle = document.createElement("input")
                    inputEle.style.height = eleHeight
                    inputEle.style.lineHeight = eleHeight
                    inputEle.setAttribute("placeholder", `Please enter ${printArea.name}`)
                    printAreaContainerEle.append(inputEle)
                }
                if(printArea.inputType === INPUT_TYPE_TEXTAREA){
                    inputEle = document.createElement("textarea")

                    inputEle.style.height = "120px"
                    inputEle.setAttribute("placeholder", `Enter ${printArea.name.toLowerCase()}\n(No content means no need. If you need a blank greeting card, you can enter 'null')`)

                }
                if(inputEle){
                    inputEle.style.width = "100%"
                    inputEle.style.marginBottom = "5px"
                    inputEle.style.marginRight = "5px"
                    inputEle.name = `properties[Card-${printArea.name}]`
                    inputEle.setAttribute("maxlength", printArea.textNum)
                    printAreaContainerEle.append(inputEle)

                }

            }
        }
    }

    CustomizeProduct.EleUtil = {
        addPrintAreas: function(printAreaInfos){

        },
        setAttributes: function(ele, attrs){
            for (let attrsKey in attrs) {
                ele.setAttribute(attrsKey, attrs[attrsKey])
            }
        },
        setStyles: function (ele, styles){
            for (let stylesKey in styles) {
                ele.style[stylesKey] = styles[stylesKey]
            }
        },
        setHtml: function(ele, html){
            ele.innerHTML=html
        },
        newTextEle: function(eleInfo){
            // new ele container
            var eleContainer = document.createElement("div")

            // new ele label
            var labelEle = document.createElement("label")
            labelEle.innerHTML=eleInfo.name
            eleContainer.append(labelEle)

            // new ele
            var inputEle = document.createElement("input")
            eleContainer.append(inputEle)
            inputEle.name = `properties[${eleInfo.attributeName}]`
            inputEle.style.width = "100%"
            inputEle.style.marginBottom = "5px"
            inputEle.setAttribute("maxLength", eleInfo.maxTextNum)

            return eleContainer
        },
        newPrintAreaEle: function(eleInfo, fonts){
            var eleHeight = "40px"

            // new ele container
            var eleContainer = document.createElement("div")
            eleContainer.style.marginBottom = "20px"

            // new ele label
            var labelEle = document.createElement("label")
            CustomizeProduct.EleUtil.setHtml(labelEle, "<span style='color:red'>*</span>"+eleInfo.name)
            eleContainer.append(labelEle)

            // new printarea row
            var printAreaRow = document.createElement("div")
            printAreaRow.style.display = "flex"
            eleContainer.append(printAreaRow)

            // new effect row
            var effectRow = document.createElement("div")
            effectRow.style.fontSize = "48px"
            eleContainer.append(effectRow)

            // new ele
            var inputEle = document.createElement("input")
            printAreaRow.append(inputEle)
            inputEle.name = `properties[${eleInfo.attributeName}]`
            inputEle.style.width = "100%"
            inputEle.style.marginBottom = "5px"
            inputEle.style.marginRight = "5px"
            inputEle.style.background = "#e9e9e9"
            inputEle.style.height = eleHeight
            inputEle.style.lineHeight = eleHeight
            inputEle.setAttribute("maxLength", eleInfo.maxTextNum)


            // new font selector
            var selectorEle = document.createElement("select")
            selectorEle.style.height = eleHeight
            selectorEle.style.lineHeight = eleHeight
            selectorEle.style.padding = "1px"
            selectorEle.style.textAlign = "center"
            if(fonts && fonts.length){
                effectRow.style.fontFamily = fonts[0].uid
                for (const font of fonts) {
                    var fontOption = document.createElement("option");
                    fontOption.setAttribute("value", font.fontName)
                    fontOption.innerHTML=font.fontName
                    selectorEle.append(fontOption)
                }
            }
            selectorEle.onchange = function(e){
                if(e.target.value){
                    for (const font of fonts) {
                        if(font.fontName === e.target.value){
                            effectRow.style.fontFamily = font.uid
                        }
                    }
                }
            }
            inputEle.onchange = function(e){
                if(e.target.value){
                    effectRow.innerHTML=e.target.value
                    selectorEle.name = `properties[${eleInfo.attributeName}-font]`
                }else{
                    effectRow.innerHTML=""
                    selectorEle.name = ``
                }
            }
            printAreaRow.append(selectorEle)

            return eleContainer
        },
        newImageEle: function(eleInfo){
            // new ele container
            var eleContainer = document.createElement("div")

            // new ele label
            var labelEle = document.createElement("label")
            CustomizeProduct.EleUtil.setHtml(labelEle, "<span style='color:red'>*</span>"+eleInfo.name)
            eleContainer.append(labelEle)

            // new ele
            var fileInputEle = document.createElement("input")
            fileInputEle.setAttribute("type", "file")
            fileInputEle.setAttribute("accept", ".jpeg,.jpg,.png")
            fileInputEle.style.marginBottom = "15px"
            eleContainer.append(fileInputEle)

            var hiddenEle = document.createElement("input")
            hiddenEle.setAttribute("type", "hidden")
            hiddenEle.name = `properties[${eleInfo.attributeName}]`
            eleContainer.append(hiddenEle)

            var imageEle = document.createElement("img")
            imageEle.style.width = "200px"
            imageEle.style.height = "200px"
            imageEle.style.display = "none"
            imageEle.style.marginBottom = "5px"
            eleContainer.append(imageEle)


            fileInputEle.onchange = CustomizeProduct.FetchUtil.uploadFile(fileInputEle,  imageEle, hiddenEle)

            return eleContainer
        },
        showBigImage: function(imageUrl){
            var bigImageContainerId = "j-big-image-container"
            var bigImageId = "j-big-image"
            var bigImageContainerEle = document.getElementById(bigImageContainerId);
            if(bigImageContainerEle === null){
                bigImageContainerEle = document.createElement("div")
                bigImageContainerEle.setAttribute("id", bigImageContainerId)
                bigImageContainerEle.style.position = "fixed"
                bigImageContainerEle.style.top = 0
                bigImageContainerEle.style.left = 0
                bigImageContainerEle.style.background = "rgba(0,0,0,0.5)"
                bigImageContainerEle.style.zIndex = 999
                bigImageContainerEle.style.width = "100vw"
                bigImageContainerEle.style.height = "100vh"
                bigImageContainerEle.style.display = "none"
                bigImageContainerEle.addEventListener("click", ()=>{
                    bigImageContainerEle.style.display = "none"
                })

                var bigImageDivEle = document.createElement("div")
                bigImageDivEle.style.position = "absolute"
                bigImageDivEle.style.width = "100%"
                bigImageDivEle.style.height = "100%"
                bigImageDivEle.style.display = "flex"
                bigImageDivEle.style.justifyItems = "center"
                bigImageDivEle.style.alignItems = "center"
                bigImageDivEle.style.justifyContent = "center"
                bigImageDivEle.style.alignContent = "center"
                bigImageContainerEle.append(bigImageDivEle)

                var bigImageEle = document.createElement("img")
                bigImageEle.setAttribute("id", bigImageId)
                bigImageEle.setAttribute("src", imageUrl)
                bigImageEle.style.height = "90vh"
                bigImageDivEle.append(bigImageEle)

                document.body.append(bigImageContainerEle)

                bigImageContainerEle.style.display = "block"

            }else{
                document.getElementById(bigImageId).setAttribute("src", imageUrl)
                bigImageContainerEle.style.display = "block"
            }

        }
    }

    CustomizeProduct.ButtonUtil = {
        getButton: function () {
            return document.querySelector("#" + BUTTON_ID);
        },
        getAddToCarTButton: function () {
            return document.querySelector("form[action='/cart/add'] [type='submit'], form[action^='/cart/add'] [type='submit'], form[data-type='add-to-cart-form'] .button, buy-buttons [type='submit'],form[action='/cart/add'] button[name='add']");
        },
        getBuyButton: function () {
            return document.querySelector("form[action='/cart/add'] [type='button'], form[action^='/cart/add'] [type='button']");
        },
        getPayButton: function () {
            return document.querySelector("form[action='/cart/add'] [data-shopify='payment-button'], form[data-type='add-to-cart-form'] [data-shopify='payment-button'],buy-buttons [data-shopify='payment-button']");
        },
        applyButton: function () {
            var addToCartButton = CustomizeProduct.ButtonUtil.getAddToCarTButton();
            if (!addToCartButton) {
                warn("Could not find cart button");
                return null;
            }
            var buyButton = CustomizeProduct.ButtonUtil.getBuyButton();
            var payButton = CustomizeProduct.ButtonUtil.getPayButton();

            var cartButtonNode = addToCartButton.cloneNode(false);
            cartButtonNode.innerText = BUTTON_TEXT;
            if (cartButtonNode.tagName.toLowerCase() === "input") {
                cartButtonNode.setAttribute("value", BUTTON_TEXT);
            }
            cartButtonNode.setAttribute("id", BUTTON_ID);
            cartButtonNode.setAttribute("name", BUTTON_ID);
            cartButtonNode.setAttribute("type", "button");
            cartButtonNode.removeAttribute("data-action");
            cartButtonNode.removeAttribute("data-add-to-cart");
            cartButtonNode.style.marginTop = "10px";
            addToCartButton.parentNode.appendChild(cartButtonNode);
            if(addToCartButton){
                warn("hidden add to cart button")
                addToCartButton.style.display = "none";
            }
            if(buyButton){
                warn("hidden buy button")
                buyButton.style.display = "none";
            }
            if(payButton){
                warn("hidden pay button")
                payButton.style.display = "none";
            }

            return CustomizeProduct.ButtonUtil.getButton();
        },
        applyEventListener: function (button, product) {
            button && button.addEventListener("click", function (event) {
                event && event.preventDefault();

                var query = window.location && window.location.search,
                    variantRegex = query.match(CustomizeProduct.Regex.variantRegex);

                var found = query.match(variantRegex);
                var variant;
                if (found && !!found.length) {
                    var variantId = found[0];
                    variant = product.variants.find(function (variant) {
                        return variant.id === variantId;
                    });
                } else {
                    variant = product.variants[0];
                }

                window.location.href = URL + (URL.indexOf("?") === -1 ? "?" : "&") + "sku=" + variant.sku;
            })
        }
    };


    CustomizeProduct.Regex = {
        productHandleRegex: /products\/([^/]+)(?:$|\.)/,
        variantRegex: /variant=([0-9]+)/
    };

    function warn(msg) {
        try {
            var debugMode = window.location.href.match(/([?&])debug/);
            debugMode && console.warn("ArtShiney: " + msg);
        } catch (e) {
        }
    }

    function info(msg) {
        try {
            var debugMode = window.location.href.match(/([?&])debug/);
            debugMode && console.info("ArtShiney: " + msg);
        } catch (e) {
        }
    }
    if(IS_CUSTOMIZE_ABLE === 'true'){
        CustomizeProduct.init();
    }
    // 购物车
    var ProductCartManager = {
        settings: {
            baseUrl: "https://www.artshiney.com/papi/design_img_thumb/",
            _customizeKeyStrings: ["design_no:", "design_no"],
            designNoPrefix: "at_",
            designNoSize: 21
        },
        init: function () {
            this._processCustomizedImages();
            var that = this;
            var observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function () {
                        that._processCustomizedImages()
                    })
                }
            );
            var observerConfig = {
                childList: true,
                subtree: true
            };
            observer.observe(document.body, observerConfig)
        },
        _processCustomizedImages: function () {
            var forms = document.querySelectorAll('form[action="/cart"]');
            this._replaceImagesInElement(forms)
        },
        _replaceImagesInElement: function (elements) {
            for (var i = 0; i < elements.length; i++) {
                var form = elements[i];
                if (!form.classList.contains("art-form-processed")) {
                    form.classList.add("art-form-processed");
                    this._parseElement(form)
                }
            }
        },
        _parseElement: function (element) {
            var childNodes = element.childNodes;
            for (var i = 0; i < childNodes.length; i++) {
                var childElement = childNodes[i];
                if (childElement.nodeType == Node.TEXT_NODE) {
                    this._findAndRemoveCustomizeKeyInfo(childElement)
                } else {
                    this._parseElement(childElement)
                }
            }
        },
        _findAndRemoveCustomizeKeyInfo: function (node) {
            for (var i = 0; i < this.settings._customizeKeyStrings.length; i++) {
                var customizeString = this.settings._customizeKeyStrings[i];
                if (node.textContent.indexOf(customizeString) != -1) {
                    node.textContent = node.textContent.replace(customizeString, "")
                }
            }
            var designNoPrefixLength = this.settings.designNoPrefix.length
            if (node.textContent.indexOf(this.settings.designNoPrefix) != -1) {
                var prefixIndex = node.textContent.indexOf(this.settings.designNoPrefix);
                var hashWithPrefix = node.textContent.substring(prefixIndex, prefixIndex + this.settings.designNoSize + designNoPrefixLength);
                var hash = hashWithPrefix;
                node.textContent = node.textContent.replace(hashWithPrefix, "");
                this._getImageForHash(hash, node);
                if (node.parentNode.textContent.trim().length == 0 && node.parentNode.tagName) {
                    node.parentNode.style.display = "none"
                }
            }
        },
        _getImageForHash: function (hash, node) {
            this._findAndReplaceImage(node.parentNode, this.settings.baseUrl + hash, true);
            this._findAndReplaceLinkImage(node.parentNode, this.settings.baseUrl + hash, true)

        },
        _findAndReplaceImage: function (node, imageUrl, scanParent) {
            return this._findAndReplaceLoop(node, imageUrl, scanParent, function (childElement, imageUrl) {
                if (childElement.tagName == "IMG") {
                    childElement.src = imageUrl;
                    childElement.setAttribute("data-widths", "[800]");
                    childElement.setAttribute("data-srcset", imageUrl + " 800w");
                    childElement.setAttribute("srcset", imageUrl + " 800w");
                    return true
                }
                return false
            })
        },
        _findAndReplaceLinkImage: function (node, imageUrl, scanParent) {
            return this._findAndReplaceLoop(node, imageUrl, scanParent, function (childElement, imageUrl) {
                if (childElement.tagName == "A" && childElement.style.backgroundImage.length > 0) {
                    childElement.style.backgroundImage = "url(" + imageUrl + ")";
                    return true
                }
                return false
            })
        },
        _findAndReplaceLoop: function (node, imageUrl, scanParent, replaceCallback) {
            if (!node) {
                return false
            }
            if (node.classList && node.classList.contains("pf-form-processed")) {
                console.warn("Looks like image was not replaced");
                return true
            }
            for (var i = 0; i < node.children.length; i++) {
                var childElement = node.children[i];
                if (replaceCallback(childElement, imageUrl)) {
                    return true
                }
                if (this._findAndReplaceLoop(childElement, imageUrl, false, replaceCallback)) {
                    return true
                }
            }
            if (scanParent) {
                return this._findAndReplaceLoop(node.parentNode, imageUrl, true, replaceCallback)
            }
            return false
        }
    };
    if (location.pathname === '/cart') {
        ProductCartManager.init();
    }

    return CustomizeProduct;
})();